export const LANGS = ['zh', 'en'] as const
export type Lang = (typeof LANGS)[number]

export function isLang(value: unknown): value is Lang {
  return typeof value === 'string' && (LANGS as readonly string[]).includes(value)
}

/** Detect the browser's preferred language (fallback when no URL prefix). */
export function detectBrowserLang(): Lang {
  const stored = localStorage.getItem('cloudtools.lang')
  if (stored === 'zh' || stored === 'en') return stored
  return typeof navigator !== 'undefined' && navigator.language?.toLowerCase().startsWith('zh')
    ? 'zh'
    : 'en'
}

/** Persist the user's explicit language choice as a cookie (read by _middleware). */
export function writeLangCookie(lang: Lang): void {
  document.cookie = `lang=${lang}; path=/; max-age=31536000; samesite=lax`
}

/** Remove a leading language segment: /zh/tools/x → /tools/x, /zh → /. */
export function stripLangPrefix(pathname: string): string {
  const [, first, ...rest] = pathname.split('/')
  if (first && isLang(first)) {
    return rest.length > 0 ? `/${rest.join('/')}` : '/'
  }
  return pathname
}

/** Add a language prefix: /tools/x → /zh/tools/x, / → /zh, /#a → /zh#a. */
export function langPrefixPath(to: string, lang: Lang): string {
  if (to === '/') return `/${lang}`
  return `/${lang}${to}`
}